import React from 'react'
import Loading from '../../loading'

export default function ResinousAddToCartModal({ error }) {
   return (
      <div className="modal fade" id="modal-addToCart" tabIndex="-1" role="dialog" aria-labelledby="addToCartModal" aria-hidden="true">
      <div className="modal-dialog modal-chip-and-color" role="document">
         <div className="modal-content">
            <div className="modal-header">
               <h3 className="modal-title">Adding products to cart</h3>
               <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
               </button>
            </div>
            <div className="modal-body">
               <div className="row p-1">
                  <Loading type="products into the shopping cart" descMessage="You will be redirected to the shopping cart once completed." error={ error } />
               </div>
            </div>
         </div>
      </div>
   </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousAddToCartModal.js